import ActionAbstract from '../ActionAbstract';

class ToggleMediaPreview extends ActionAbstract {

    static get ID() {
        return 'actions:main:toggleMediaPreview';
    }

    run(state) {
        return this.composeState(state, {
            main: {
                mediaPreviewOpen: this.getParam('open')
            }
        });
    }

    toggle(state) {
        let forcedState = this.getParam('open');
        let newState = forcedState !== undefined ? forcedState : !!!state;
        return newState;
    }

}

export default ToggleMediaPreview;